import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Breadcrumbs,
  Typography,
  Link,
  IconButton,
} from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

export default function Navbar({ open, toggleDrawer }) {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const breadcrumbLabels = {
    beranda: "Beranda",
    daftarpetugas: "Daftar Petugas",
    pantaulapangan: "Pantau Lapangan",
    aktivitaspetugas: "Aktivitas Petugas",
  };

  const isBeranda = location.pathname === "/beranda";

  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${open ? 240 : 72}px)`,
        ml: open ? "240px" : "72px",
        transition: "width 0.3s, margin-left 0.3s",
        backgroundColor: "#ffffffff",
        boxShadow: "none",
        borderBottom: "none",
      }}
    >
      <Toolbar
        sx={{
          minHeight: 56,
          display: "flex",
          alignItems: "center",
          px: 2.5,
          gap: 1,
        }}
      >

        {isBeranda ? (
          <Typography sx={{ fontSize: 14, color: "#1F2E6E", fontWeight: 500 }}>
            Beranda
          </Typography>
        ) : (
          <Breadcrumbs
            separator="›"
            aria-label="breadcrumb"
            sx={{
              "& .MuiBreadcrumbs-separator": { color: "#94a3b8" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <Link
              component={RouterLink}
              underline="hover"
              color="#94a3b8"
              to="/beranda"
              sx={{ fontSize: 14, fontWeight: 500 }}
            >
              Beranda
            </Link>

            {pathnames.map((value, index) => {
              const to = `/${pathnames.slice(0, index + 1).join("/")}`;
              const isLast = index === pathnames.length - 1;
              const label =
                breadcrumbLabels[value] ||
                value.charAt(0).toUpperCase() + value.slice(1);

              return isLast ? (
                <Typography
                  key={to}
                  sx={{ fontSize: 14, color: "#1F2E6E", fontWeight: 500 }}
                >
                  {label}
                </Typography>
              ) : (
                <Link
                  key={to}
                  component={RouterLink}
                  underline="hover"
                  color="#94a3b8"
                  to={to}
                  sx={{ fontSize: 14, fontWeight: 500 }}
                >
                  {label}
                </Link>
              );
            })}
          </Breadcrumbs>
        )}
      </Toolbar>
    </AppBar>
  );
}
